module.exports = "span:not(:last-child)::after,time:not(:last-child)::after{content:' '}.count,time{font-weight:bold}\n"


//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/DayDetails/DayDetails.scss
// module id = 34
// module chunks = 0 1